import AddSaleMixin from '../AddSaleMixin';
import ProductsTable from '../../components/productsTable/ProductsTable.vue';

export default {
  name: 'AddSaleTable',
  props: ['action_id', 'id'],
  mixins: [AddSaleMixin],
  components: { ProductsTable },
  data() {
    return {
      activePicker: null,
      dateInstallation: null,
      ShowDetails: false,
    };
  },
  computed: {
    // Продукты акции (завершённой акции нет в currentActions - берём из продажи)
    products() {
      return this.currentAction?.products ?? this.sale?.action?.products ?? null;
    },
    ticket() {
      if (this.id === 'null') {
        return null;
      }
      return this.salesTicket.find(el => el.id === Number(this.id));
    },
    salesTicket() {
      return this.$store.state.sales.salesTypical;
    },
    computedDateFormatted() {
      return this.FormatDate(this.dateInstallation);
    },
  },

  methods: {
    /** Записать дату */
    SaveDate(date) {
      this.$refs.menu.save(date);
    },
    /** Форматировать дату */
    FormatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    /**
     * Обработка нажатия на кнопку в поле ввода количества, запрещаем вводить символ минуса "-"
     * @param event
     */
    onQuantityKeydown(event) {
      if (event.key === '-') {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    openItemDialog(event, item) {
      event.stopPropagation();
      event.preventDefault();
      if (item.checked) {
        item.mobileDialog = true;
      }
    },
    /**
     * Метод добавления новой продажи.
     */
    onSubmit(is_draft = false) {
      this.submitIsProcessing = true;
      const app = this;
      let restURL = 'sales/api/sale/create';

      const sale = {
        register_type: 'web',
        ...this.form,
        is_draft,
        positions: this.$refs.table.getPositions(),
        profile_id: this.user.profile_id,
        action_id: this.action_id,
      };

      if (app.saleID !== 'null') {
        restURL = 'sales/api/sale/update';
        sale.sale_id = app.sale.id;
        sale.action_id = app.sale.action_id;
        sale.register_type = 'web';
      }

      app.$store.getters.axl
        .post(restURL, sale)
        .then(() => {
          this.$store.dispatch('sales/GetSales', {
            profile_id: this.$store.state.user.profile_id,
          });
          app.$router.push('/sales/installation');
          app.$store.dispatch('ShowInfo', 'Монтаж отправлен на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          this.submitIsProcessing = false;
        });
    },
    setDataPreload() {
      if (this.saleID !== 'null' && this.saleID !== undefined) {
        const app = this;
        this.form = { ...app.sale };
        if (app.sale.address) {
          this.addresses.push({
            value: app.sale.address,
          });
        }
        if (app.sale.city) {
          this.cities.push({ ...app.sale.city });
        }
      }
    },
  },
  mounted() {
    this.setDataPreload();
  },
};
